import { defineComponent, computed, watch, ref, toRef, nextTick, onMounted, createElementBlock, openBlock, withKeys, normalizeClass, createElementVNode, createVNode, unref, withCtx, createCommentVNode, toDisplayString, normalizeStyle, Fragment, renderList, createTextVNode, withDirectives, vShow, createBlock, mergeProps } from 'vue';
import { FormKit, FormKitIcon, submitForm } from '@formkit/vue';
import { getNode } from '@formkit/core';
import _sfc_main$1 from './basler-components.es121.js';
import _sfc_main$2 from './basler-components.es157.js';
/* empty css                        */
import _sfc_main$3 from './basler-components.es155.js';
/* empty css                        */
import { useWindowSize } from './basler-components.es354.js';
import _sfc_main$4 from './basler-components.es83.js';
/* empty css                       */
import IconClose from './basler-components.es374.js';
import IconLeft from './basler-components.es370.js';
import { useViewport } from './basler-components.es377.js';

const _hoisted_1 = { class: "search-box__outer" };
const _hoisted_2 = {
  key: 0,
  class: "search-box__topbar"
};
const _hoisted_3 = { class: "search-box__topbar-inner" };
const _hoisted_4 = { class: "visually-hidden" };
const _hoisted_5 = { class: "search-box__inner-wrapper" };
const _hoisted_6 = { class: "search-box__inner" };
const _hoisted_7 = { class: "search-box__search-bar-group" };
const _hoisted_8 = { class: "search-box__btn-back-wrapper" };
const _hoisted_9 = { class: "visually-hidden" };
const _hoisted_10 = ["aria-label"];
const _hoisted_11 = { class: "search-box__offset-content" };
const _hoisted_12 = {
  key: 0,
  class: "search-box__popular-searches"
};
const _hoisted_13 = { class: "search-box__headline" };
const _hoisted_14 = {
  key: 0,
  class: "search-box__list-item"
};
const _hoisted_15 = { class: "search-box__results-container" };
const _hoisted_16 = {
  key: 0,
  class: "search-box__auto-suggestions"
};
const _hoisted_17 = { class: "search-box__headline" };
const _hoisted_18 = { key: 0 };
const _hoisted_19 = { class: "search-box__results" };
const _hoisted_20 = {
  key: 0,
  class: "search-box__result-items"
};
const _hoisted_21 = { class: "search-box__show-all" };
const _hoisted_22 = {
  key: 1,
  class: "search-box__no-results"
};
const _hoisted_23 = ["innerHTML"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "SearchBox",
  props: {
    searchInputLabel: {},
    searchInputPlaceholder: {},
    isOpen: { type: Boolean, default: false },
    searchTypes: {},
    formData: {},
    popularSearches: {},
    suggestions: {},
    results: {},
    closeButtonLabel: {},
    submitButtonLabel: { default: "Submit search" }
  },
  emits: ["change", "search-type-change", "submit", "close", "navigate", "focus"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const { width } = useWindowSize();
    const isDesktop = computed(() => {
      return width.value >= 1024;
    });
    watch(
      () => props.isOpen,
      (isOpen) => {
        if (isOpen) {
          const searchInput = document.querySelector('.search-box input[type="search"]');
          searchInput && setFocusToElement(searchInput);
        } else {
          showContentOnMobile.value = false;
        }
      }
    );
    const rowsCount = computed(() => {
      let rows = 1;
      if (props.popularSearches && props.popularSearches.items.length) {
        rows = props.popularSearches.items.length;
        if (rows > 5) {
          rows = Math.ceil(props.popularSearches.items.length / 2);
        }
      }
      return rows;
    });
    const showContentOnMobile = ref(false);
    const suggestions = toRef(props, "suggestions");
    const suggestionsIndex = ref(-1);
    const showSuggestions = ref(false);
    const suggestionsUid = Date.now().toString(36) + Math.random().toString(36).substr(2);
    const hasSuggestions = computed(() => {
      return !!suggestions.value && Array.isArray(suggestions.value.items) && suggestions.value.items.length > 0;
    });
    const hasResults = computed(() => {
      return !!props.results && Array.isArray(props.results.items) && props.results.items.length > 0;
    });
    const getsuggestionItemUid = computed(() => {
      if (hasSuggestions.value && suggestionsIndex.value > -1) {
        return `${suggestionsUid}-${suggestionsIndex.value}`;
      }
      return void 0;
    });
    const setFocusToElement = async (element) => {
      await nextTick();
      element?.focus();
    };
    const submitFormData = (formData) => {
      emit("submit", formData);
    };
    const onInputChange = (value) => {
      if (hasSuggestions.value) {
        showSuggestions.value = true;
      }
      emit("change", value);
    };
    const onInputFocus = () => {
      emit("focus");
      showContentOnMobile.value = true;
      if (hasSuggestions.value) {
        showSuggestions.value = true;
      }
    };
    const onInputBlur = () => {
      showContentOnMobile.value = false;
    };
    const firstInputEventOnInitTriggered = ref(false);
    const triggerFilterChange = (value) => {
      emit("search-type-change", value);
      if (!firstInputEventOnInitTriggered.value) {
        firstInputEventOnInitTriggered.value = true;
        return;
      }
    };
    const triggerSubmit = () => {
      submitForm("search-box-form");
      if (!isDesktop.value) {
        const submitBtn = document.querySelector(".search-box #search-box-submit");
        submitBtn && setFocusToElement(submitBtn);
      }
    };
    const selectSuggestion = (suggestion, event) => {
      if (event) {
        event.preventDefault();
      }
      showSuggestions.value = false;
      getNode("search-box-value")?.input(suggestion.text).then(() => {
        triggerSubmit();
      });
    };
    const onInputKeydown = (keyboardEvent) => {
      switch (keyboardEvent.key) {
        case "ArrowUp":
          keyboardEvent.preventDefault();
          if (suggestions.value && hasSuggestions.value) {
            showSuggestions.value = true;
            suggestionsIndex.value = suggestionsIndex.value > 0 ? suggestionsIndex.value - 1 : suggestions.value.items.length - 1;
            suggestions.value.items.forEach((item) => item.selected = false);
            suggestions.value.items[suggestionsIndex.value].selected = true;
          }
          break;
        case "ArrowDown":
          keyboardEvent.preventDefault();
          if (suggestions.value && hasSuggestions.value) {
            showSuggestions.value = true;
            suggestionsIndex.value = suggestionsIndex.value < suggestions.value.items.length - 1 ? suggestionsIndex.value + 1 : 0;
            suggestions.value.items.forEach((item) => item.selected = false);
            suggestions.value.items[suggestionsIndex.value].selected = true;
          }
          break;
        case "Enter":
          keyboardEvent.preventDefault();
          if (suggestions.value && hasSuggestions.value && suggestionsIndex.value > -1) {
            selectSuggestion(suggestions.value.items[suggestionsIndex.value]);
          } else {
            triggerSubmit();
          }
          break;
        case "Escape":
          if (showSuggestions.value) {
            keyboardEvent.stopPropagation();
          }
          showSuggestions.value = false;
          suggestionsIndex.value = -1;
          break;
      }
    };
    const searchBoxClose = () => {
      emit("close");
    };
    onMounted(() => {
      useViewport();
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass([
          "search-box",
          {
            "is-open": props.isOpen,
            "show-content-on-mobile": showContentOnMobile.value
          }
        ]),
        tabindex: "0",
        onKeydown: withKeys(searchBoxClose, ["esc"])
      }, [
        createElementVNode("div", _hoisted_1, [
          createVNode(unref(FormKit), {
            type: "form",
            id: "search-box-form",
            "form-class": "search-box__form",
            actions: false,
            value: _ctx.formData,
            "submit-attrs": {
              id: "search-box-submit",
              "aria-label": "Search"
            },
            onSubmit: submitFormData
          }, {
            default: withCtx(() => [
              _ctx.searchTypes ? (openBlock(), createElementBlock("div", _hoisted_2, [
                createElementVNode("div", _hoisted_3, [
                  createVNode(unref(FormKit), {
                    type: "radio",
                    name: "search-type",
                    "outer-class": "search-box__search-type",
                    label: _ctx.searchTypes.label,
                    options: _ctx.searchTypes.options,
                    onInput: triggerFilterChange
                  }, null, 8, ["label", "options"]),
                  _ctx.closeButtonLabel ? (openBlock(), createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "search-box__close-button",
                    onClick: searchBoxClose
                  }, [
                    createVNode(unref(IconClose)),
                    createElementVNode("span", _hoisted_4, toDisplayString(_ctx.closeButtonLabel), 1)
                  ])) : createCommentVNode("", true)
                ])
              ])) : createCommentVNode("", true),
              createElementVNode("div", _hoisted_5, [
                createElementVNode("div", _hoisted_6, [
                  createElementVNode("div", _hoisted_7, [
                    createElementVNode("div", _hoisted_8, [
                      createElementVNode("button", {
                        type: "button",
                        class: "search-box__btn-back",
                        onClick: onInputBlur
                      }, [
                        createVNode(unref(IconLeft)),
                        createElementVNode("span", _hoisted_9, toDisplayString(_ctx.closeButtonLabel), 1)
                      ])
                    ]),
                    createVNode(unref(FormKit), {
                      type: "search",
                      id: "search-box-value",
                      name: "search-value",
                      "outer-class": "fk-search-bar",
                      label: _ctx.searchInputLabel,
                      placeholder: _ctx.searchInputPlaceholder ? _ctx.searchInputPlaceholder : _ctx.searchInputLabel,
                      "floating-label": false,
                      autocomplete: "off",
                      role: "combobox",
                      "aria-expanded": showSuggestions.value,
                      "aria-owns": suggestionsUid,
                      "aria-activedescendant": getsuggestionItemUid.value,
                      onInput: onInputChange,
                      onFocus: onInputFocus,
                      onKeydown: onInputKeydown
                    }, {
                      suffix: withCtx(() => [
                        createElementVNode("button", {
                          type: "submit",
                          class: "fk-search-bar__submit",
                          tabindex: "-1",
                          "aria-label": _ctx.submitButtonLabel
                        }, [
                          createVNode(unref(FormKitIcon), { icon: "search" })
                        ], 8, _hoisted_10)
                      ]),
                      _: 1
                    }, 8, ["label", "placeholder", "aria-expanded", "aria-activedescendant", "onInput"])
                  ]),
                  createElementVNode("div", _hoisted_11, [
                    _ctx.popularSearches && !hasSuggestions.value && !showSuggestions.value && !hasResults.value ? (openBlock(), createElementBlock("div", _hoisted_12, [
                      createElementVNode("div", _hoisted_13, toDisplayString(_ctx.popularSearches.title), 1),
                      createElementVNode("ul", {
                        class: "search-box__list",
                        style: normalizeStyle(`--rows-count: ${rowsCount.value}`)
                      }, [
                        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.popularSearches.items, (linkItem) => {
                          return openBlock(), createElementBlock(Fragment, { key: linkItem }, [
                            linkItem.link ? (openBlock(), createElementBlock("li", _hoisted_14, [
                              createVNode(_sfc_main$1, {
                                uri: linkItem.link.uri,
                                class: "search-box__list-item-element",
                                onClick: _cache[0] || (_cache[0] = ($event) => emit("navigate"))
                              }, {
                                default: withCtx(() => [
                                  createTextVNode(toDisplayString(linkItem.text), 1)
                                ]),
                                _: 2
                              }, 1032, ["uri"])
                            ])) : createCommentVNode("", true)
                          ], 64);
                        }), 128))
                      ], 4)
                    ])) : createCommentVNode("", true),
                    createElementVNode("div", _hoisted_15, [
                      suggestions.value && suggestions.value.items ? (openBlock(), createElementBlock("div", _hoisted_16, [
                        createElementVNode("h2", _hoisted_17, toDisplayString(suggestions.value.title), 1),
                        withDirectives(createVNode(_sfc_main$2, {
                          id: suggestionsUid,
                          label: suggestions.value.label,
                          items: suggestions.value.items,
                          "results-found-text": suggestions.value.resultsFoundText,
                          "no-results-text": suggestions.value.noResultsText,
                          onSelected: selectSuggestion
                        }, null, 8, ["label", "items", "results-found-text", "no-results-text"]), [
                          [vShow, showSuggestions.value && hasSuggestions.value]
                        ]),
                        !hasSuggestions.value ? (openBlock(), createElementBlock("p", _hoisted_18, toDisplayString(suggestions.value.noResultsText), 1)) : createCommentVNode("", true)
                      ])) : createCommentVNode("", true),
                      createElementVNode("div", _hoisted_19, [
                        _ctx.results && Object.keys(_ctx.results).length ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                          createElementVNode("h2", {
                            class: normalizeClass(["search-box__headline", { "has-loading-bar": _ctx.results.isLoading }])
                          }, toDisplayString(_ctx.results.title), 3),
                          hasResults.value ? (openBlock(), createElementBlock("div", _hoisted_20, [
                            (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.results.items.slice(0, 3), (item) => {
                              return openBlock(), createBlock(_sfc_main$3, {
                                key: item.title,
                                title: item.title,
                                subtitle: item.subtitle,
                                excerpt: item.excerpt,
                                link: item.link,
                                media: item.media,
                                onClick: _cache[1] || (_cache[1] = ($event) => emit("navigate"))
                              }, null, 8, ["title", "subtitle", "excerpt", "link", "media"]);
                            }), 128)),
                            createElementVNode("div", _hoisted_21, [
                              _ctx.results.items.length > 3 ? (openBlock(), createBlock(_sfc_main$1, mergeProps({ key: 0 }, _ctx.results.showAll.link, {
                                class: "search-box__show-all-link",
                                onClick: _cache[2] || (_cache[2] = ($event) => emit("navigate"))
                              }), {
                                default: withCtx(() => [
                                  createTextVNode(toDisplayString(_ctx.results.showAll.text), 1)
                                ]),
                                _: 1
                              }, 16)) : createCommentVNode("", true)
                            ])
                          ])) : !_ctx.results.isLoading && _ctx.results.noItems ? (openBlock(), createElementBlock("div", _hoisted_22, [
                            createElementVNode("div", {
                              class: "rte-text",
                              innerHTML: _ctx.results.noItems.text
                            }, null, 8, _hoisted_23),
                            _ctx.results.noItems.linkItem ? (openBlock(), createBlock(_sfc_main$4, {
                              key: 0,
                              link: _ctx.results.noItems.linkItem.link,
                              onClick: _cache[3] || (_cache[3] = ($event) => emit("navigate"))
                            }, {
                              default: withCtx(() => [
                                createTextVNode(toDisplayString(_ctx.results.noItems.linkItem.title), 1)
                              ]),
                              _: 1
                            }, 8, ["link"])) : createCommentVNode("", true)
                          ])) : createCommentVNode("", true)
                        ], 64)) : createCommentVNode("", true)
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["value"])
        ])
      ], 34);
    };
  }
});

export { _sfc_main as default };
